import moment from 'moment'

const toTable = (group) => {
  return {
    id: group.id,
    name: group.name,
    created: moment(group.created_at).unix(),
    relations: {
      members: group.members,
      modules: group.modules
    }
  }
}

export default {
  set (state) {
    let set = []
    for (const view in state.views) {
      const data = state.views[view].ids.map((id) => state.views[view].index[id])
      set = set.concat(data)
    }

    return set
  },

  view (state) {
    return (view) => {
      return state.views[view].ids.map((id) => state.views[view].index[id]).map(toTable)
    }
  },

  unsavedChanges (state) {
    const current = state.current
    const formFields = state.forms.update.fields
    let unsaved = false

    if (!current) {
      return unsaved
    }

    if (formFields.name && current.name !== formFields.name) {
      unsaved = true
    }

    if (formFields.description && current.description !== formFields.description) {
      unsaved = true
    }

    return unsaved
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/groups/getters.js